module.exports = __webpack_public_path__ + "static/media/francisco_beltrao.eb4a9a28.jpg";